import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";

import { DocMeta } from "@template-ui/decorators";
import { UiLibraryModule } from "@template-ui/template-ui.module";

@DocMeta({
  title: "Sample EzSectionSampleComponent",
  hide: true
})
@Component({
    selector: 'ui-section-sample, ez-section-sample',
    imports: [CommonModule, UiLibraryModule],
    templateUrl: './ez-section-sample.component.html'
})
export class EzSectionSampleComponent {

}